import { isUndefined } from 'lodash'
import { TFunction } from 'i18next'
import { ActiveFilter, NotificationsFilterWithoutSetter } from './types'
import { sendMessageToReactNative } from '@e3dc-react/shell/Libs/react-native'
import { NotificationOverviewModel } from './models/notifications.model'

const GET_PUSH_NOTIFICATION_TYPE = 'get-push-notification-token'

/**
 * This function turns an array of active filters into a Apache Lucene Query Syntax filter
 * and a sort parameter to sort the results
 * @param activeFilters
 * @returns filter and sort for a authFetch payload parameter
 */
export const parseActiveFilter = (activeFilters: NotificationsFilterWithoutSetter): ActiveFilter => {
  const result: ActiveFilter = {}
  const filters = [] as string[]
  const { readFilter } = activeFilters

  if (readFilter && !isUndefined(readFilter.activeValue)) {
    filters.push(`${readFilter.fieldName}=${readFilter.activeValue}`)
  }

  result.filter = filters.join(' AND ')

  return result
}

/**
 * Sends a request to react native, which is then sent via event.
 * See ../react-native/use-react-native-messages.ts
 */
export const getPushNotificationTokenFromReactNative = (isWebview: boolean): void => {
  if (isWebview) {
    const content = { type: GET_PUSH_NOTIFICATION_TYPE }
    sendMessageToReactNative(content)
  }
}

/**
 * Resolves the display label for a notification's recipient user level,
 * from most specific (combination of roles) to most general (single service role).
 */
export const getNotificationUserLevelLabel = (notification: NotificationOverviewModel, t: TFunction): string | undefined => {
  const { user, installer, partner, e3dc_admin, e3dc_root, e3dc_service, ext_service } = notification

  if (user && installer && partner) {
    return t('common.all')
  }
  if (installer && partner && !user) {
    return t('framework.userBadge.userlevel.partner-and-installer')
  }
  if (user) {
    return t('framework.userBadge.userlevel.USER')
  }
  if (installer) {
    return t('framework.userBadge.userlevel.INSTALLER')
  }
  if (partner) {
    return t('framework.userBadge.userlevel.PARTNER')
  }
  if (e3dc_admin) {
    return t('framework.userBadge.userlevel.E3DC_ADMIN')
  }
  if (e3dc_root) {
    return t('framework.userBadge.userlevel.E3DC_ROOT')
  }
  if (e3dc_service) {
    return t('framework.userBadge.userlevel.E3DC_SERVICE')
  }
  if (ext_service) {
    return t('framework.userBadge.userlevel.EXT_SERVICE')
  }
  if (!installer && !partner && !user) {
    return t('framework.userBadge.userlevel.E3DC_SERVICE')
  }
}
